import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import SEO from '../components/SEO';
// Título y descripción: los mismos que scripts/html-por-ruta.js pone en el HTML estático.
import SEO_RUTAS from '../config/seo-rutas.json';
import Icono from '../components/Icono';
import MapaTI from '../components/MapaTI';
import { BotonWhatsApp, CtaFinal, Preguntas } from '../components/comunes';
import { lineasDeServicio } from '../config/servicios';

// Sectores donde Kiwi ya trabaja hoy (de los proyectos reales: distribución de
// equipo médico, importadora con tiendas, taller, hacienda ganadera, etc.).
// Solo sectores y sin nombres ni logos: publicar el nombre de un cliente
// requiere su permiso. PENDIENTE validar la lista con Adán.
const sectores = [
  'Distribución de equipo médico',
  'Importación y tiendas',
  'Distribución y comercio',
  'Talleres',
  'Ganadería',
];

const pasos = [
  {
    titulo: 'Conversamos',
    texto: 'Por WhatsApp o en una reunión. Nos cuenta qué le está costando tiempo o dinero y vemos si podemos ayudar.',
  },
  {
    titulo: 'Le proponemos por escrito',
    texto: 'Qué vamos a hacer, en cuánto tiempo y cuánto cuesta. Sin letra pequeña y antes de empezar.',
  },
  {
    titulo: 'Lo hacemos y nos quedamos',
    texto: 'Trabajamos por etapas que usted puede revisar, y seguimos disponibles cuando ya está funcionando.',
  },
];

// Respuestas solo con lo que el sitio o la memoria del proyecto confirman. Las
// de cobro y cobertura están marcadas para que Adán las valide.
const preguntas = [
  {
    pregunta: '¿Trabajan con empresas pequeñas?',
    respuesta:
      'Sí. Trabajamos con pymes que no tienen departamento de TI y con empresas que sí lo tienen y necesitan apoyo en algo puntual, como la red, SAP o una aplicación.',
  },
  {
    pregunta: '¿Cómo cobran?',
    respuesta:
      'Depende del servicio. Los proyectos se cotizan por escrito antes de empezar y el soporte continuo se acuerda como un servicio mensual. La primera conversación no tiene costo.',
  },
  {
    pregunta: '¿Cuánto cuesta Kiwi ERP?',
    respuesta:
      'La facturación electrónica y el inventario no tienen costo. Los módulos adicionales, como cobros, compras o contabilidad, se cotizan según lo que su empresa necesite.',
  },
  {
    pregunta: '¿Qué necesito para facturar electrónicamente?',
    respuesta:
      'Estar inscrito en Hacienda, el usuario y la contraseña del ATV para el envío de comprobantes, y la llave criptográfica con su PIN. Si todavía no los tiene, le ayudamos a generarlos.',
  },
  {
    pregunta: '¿Pueden trabajar sobre el SAP Business One que ya tenemos?',
    respuesta:
      'Sí. Hacemos reportes, integraciones, formatos y mantenimiento del servidor sobre su instalación actual. No vendemos licencias de SAP.',
  },
  {
    pregunta: '¿Atienden en sitio o solo de forma remota?',
    respuesta:
      'Las dos cosas. La mayoría de los casos se resuelven de forma remota, y vamos a sus oficinas cuando el trabajo lo requiere.',
  },
];

function Home() {
  return (
    <div className="inicio">
      <SEO
        title={SEO_RUTAS['/'].title}
        description={SEO_RUTAS['/'].description}
        keywords="soporte TI Costa Rica, redes empresariales, desarrollo de software a medida, SAP Business One Costa Rica, factura electrónica 4.4, Kiwi ERP"
        canonical="/"
      />

      {/* HÉROE: qué hacemos y para quién, con la acción principal a la vista. */}
      <section className="heroe" aria-labelledby="heroe-titulo">
        <div className="contenedor heroe__rejilla">
          <div className="heroe__texto">
            <p className="heroe__lugar">
              <Icono nombre="ubicacion" />
              Pymes de Costa Rica
            </p>
            <h1 id="heroe-titulo">El equipo de TI de su empresa, sin tener que contratarlo.</h1>
            <p className="heroe__entrada">
              Mantenemos sus computadoras, su red y sus servidores funcionando, construimos el software que le hace
              falta y le damos Kiwi ERP para facturar a Hacienda.
            </p>
            <div className="grupo-botones">
              <BotonWhatsApp mensaje="Hola, quiero conversar sobre la tecnología de mi empresa." />
              {/* Página estática aparte (public/erp/): <a>, no <Link>. */}
              <a className="btn btn--secundario" href="/erp/">
                Probar Kiwi ERP
              </a>
            </div>
          </div>
          <div className="heroe__mapa">
            <MapaTI />
          </div>
        </div>
      </section>

      {/* SERVICIOS: índice con una línea de beneficio por servicio. */}
      <section className="seccion seccion--niebla" aria-labelledby="servicios-titulo">
        <div className="contenedor">
          <div className="encabezado">
            <h2 id="servicios-titulo">Lo que hacemos</h2>
            <p>Seis frentes, un mismo equipo. Si algo de su tecnología no funciona, empieza por aquí.</p>
          </div>
          <ul className="indice-servicios">
            {lineasDeServicio.map((s) => {
              const contenido = (
                <>
                  <span className="icono-marco">
                    <Icono nombre={s.icono} />
                  </span>
                  <span className="indice-servicios__texto">
                    <span className="indice-servicios__titulo">{s.titulo}</span>
                    <span className="indice-servicios__beneficio">{s.beneficio}</span>
                  </span>
                  <Icono nombre="flecha" className="indice-servicios__flecha" />
                </>
              );
              return (
                <li key={s.titulo}>
                  {s.href ? (
                    <a className="indice-servicios__enlace" href={s.href}>
                      {contenido}
                    </a>
                  ) : (
                    <Link className="indice-servicios__enlace" to={s.to}>
                      {contenido}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </section>

      {/* KIWI ERP: producto propio, con una captura real de la aplicación. */}
      <section className="seccion zona-oscura erp-bloque" aria-labelledby="erp-titulo">
        <div className="contenedor erp-bloque__rejilla">
          <div>
            <p className="erp-bloque__producto">Kiwi ERP, nuestro sistema propio</p>
            <h2 id="erp-titulo">Facture a Hacienda y sepa qué hay en bodega. La base es gratis.</h2>
            <ul className="lista-check erp-bloque__lista">
              <li>
                <Icono nombre="check" />
                <span>Factura electrónica 4.4, notas de crédito y débito y factura electrónica de compra.</span>
              </li>
              <li>
                <Icono nombre="check" />
                <span>Inventario por bodega y lote, con vencimientos y tomas físicas.</span>
              </li>
              <li>
                <Icono nombre="check" />
                <span>En línea, desde la computadora o el teléfono. No hay que instalar nada.</span>
              </li>
              <li>
                <Icono nombre="check" />
                <span>Módulos para cobros, compras y contabilidad cuando los necesite.</span>
              </li>
            </ul>
            <div className="grupo-botones">
              <a className="btn btn--primario" href="/erp/">
                Conocer Kiwi ERP
              </a>
              <BotonWhatsApp variante="secundario" mensaje="Hola, quiero información de Kiwi ERP.">
                Preguntar por WhatsApp
              </BotonWhatsApp>
            </div>
          </div>
          <figure className="erp-bloque__captura">
            <img
              src="/erp/img/inicio-960.webp"
              alt="Pantalla de inicio de Kiwi ERP con los pendientes del día: comprobantes por responder, cobros vencidos y mercadería por vencer."
              width="960"
              height="455"
              loading="lazy"
              decoding="async"
            />
            <figcaption>Pantalla de inicio de Kiwi ERP.</figcaption>
          </figure>
        </div>
      </section>

      {/* PRUEBA SOCIAL HONESTA: sectores reales, sin logos ni testimonios inventados. */}
      <section className="seccion" aria-labelledby="sectores-titulo">
        <div className="contenedor sectores">
          <div className="sectores__texto">
            <h2 id="sectores-titulo">Ya trabajamos con empresas de</h2>
            <p>
              Desde la red de una importadora con varias tiendas hasta los reportes de SAP de una distribuidora. Le
              contamos casos parecidos al suyo en la primera conversación.
            </p>
          </div>
          <ul className="sectores__lista">
            {sectores.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* CÓMO TRABAJAMOS: sí es una secuencia, por eso va numerada. */}
      <section className="seccion seccion--niebla" aria-labelledby="pasos-titulo">
        <div className="contenedor">
          <div className="encabezado">
            <h2 id="pasos-titulo">Cómo trabajamos</h2>
            <p>Tres pasos, siempre los mismos. Usted sabe en qué etapa está su proyecto.</p>
          </div>
          <ol className="pasos">
            {pasos.map((p, i) => (
              <li key={p.titulo} className="pasos__item">
                <span className="pasos__numero" aria-hidden="true">
                  {i + 1}
                </span>
                <h3>{p.titulo}</h3>
                <p>{p.texto}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <section className="seccion" aria-labelledby="faq-titulo">
        <div className="contenedor faq-rejilla">
          <div className="encabezado">
            <h2 id="faq-titulo">Preguntas frecuentes</h2>
            <p>
              ¿No ve la suya? <Link to="/contacto">Escríbanos</Link> y le respondemos.
            </p>
          </div>
          <Preguntas items={preguntas} />
        </div>
      </section>

      <CtaFinal />
    </div>
  );
}

export default Home;
